<template>
  <span :class="badgeClass">{{ method }}</span>
</template>

<script>
export default {
  name: 'ApiDocBadge',
  props: {
    method: {
      type: String,
      required: true,
    },
  },
  computed: {
    badgeClass() {
      let result = 'badge me-2 ';
      switch (this.method) {
      case 'POST':
        result += 'bg-info';
        break;
      case 'GET':
        result += 'bg-primary';
        break;
      case 'PUT':
      case 'PATCH':
        result += 'bg-success';
        break;
      case 'DELETE':
        result += 'bg-danger';
        break;
      default:
        result += 'bg-secondary';
      }
      return result;
    },
  },
};
</script>
